import React from 'react'
import Swap from '../container/Swap/Swap.container'

const SwapPage = () => {
  return (
    <Swap/>
  )
}

export default SwapPage